import React from "react";
import { IconProps } from "./dto";

export function SmartphoneIcon(props: IconProps) {
    return (
        <svg width={props.size} height={props.size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.99992 12.0002H8.00659M4.66659 1.3335H11.3333C12.0696 1.3335 12.6666 1.93045 12.6666 2.66683V13.3335C12.6666 14.0699 12.0696 14.6668 11.3333 14.6668H4.66659C3.93021 14.6668 3.33325 14.0699 3.33325 13.3335V2.66683C3.33325 1.93045 3.93021 1.3335 4.66659 1.3335Z" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}